'use strict';

var $ = require('jquery');
import anime from 'animejs/lib/anime.es.js';
import 'waypoints/lib/noframework.waypoints.min.js';


$(function() {

     var animatednavigation = document.querySelectorAll('.animated-link');
     var animatefrontpagelinks = document.querySelectorAll('.link-ani-opa');
     var animatecitys = document.querySelectorAll('.link-ani-opa-city');
     var animatedfrontpageposts = document.querySelectorAll('.animated-article');
     var animatedfrontpagefirstposts = document.querySelectorAll('.animated-article-first');
     var trukani = document.querySelectorAll('.truck-link');
     anime({
               targets: animatednavigation,
               translateY: 25,
               duration: 1000,
               delay: anime.stagger(50)
          });
     function isScrolledIntoView(elem) {
          var docViewTop = $(window).scrollTop();
          var docViewBottom = docViewTop + $(window).height();
          var elemTop = $(elem).offset().top;
          var elemBottom = (elemTop + $(elem).height());
          return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
     }

          function allscrollanis(){
               if($('.animate-city-trigger').length > 0){
                    if (isScrolledIntoView('.animate-city-trigger') === true) {
                         $('.city-ani-startter').removeClass('animate-city-trigger');
                         anime({
                              targets: animatecitys,
                              keyframes: [
                                   {opacity: 0},
                                   {opacity: 1}
                              ],
                              duration: 100,
                              delay: anime.stagger(40)
                         });
                    }
               }     
               if($('.animate-s-trigger').length > 0){
                    if (isScrolledIntoView('.animate-s-trigger') === true) {
                         if ($(window).width() > 767) {
                         $('.link-ani-startter').removeClass('animate-s-trigger');
                              anime({
                                   targets: animatefrontpagelinks,
                                   keyframes: [
                                        {opacity: 0},
                                        {opacity: 1}
                                   ],
                                   duration: 80,
                                   delay: anime.stagger(80)
                              });
                         }
                    }
               }    
               if($('.animated-articles-trigger').length > 0){
                    if (isScrolledIntoView('.animated-articles-trigger') === true) {
                         if ($(window).width() > 767) {
                              $('.article-ani-startter').removeClass('animated-articles-trigger');
                              anime({
                                   targets: animatedfrontpageposts,
                                   keyframes: [
                                        {opacity: 0, translateX: 250},
                                        {opacity: 1, translateX: 0}
                                   ],
                                   duration: 800,
                                   easing: 'easeOutExpo',
                                   delay: anime.stagger(250)
                              });
                              anime({
                                   targets: animatedfrontpagefirstposts,
                                   keyframes: [
                                        {opacity: 0, translateX: -250},
                                        {opacity: 1, translateX: 0}
                                   ],
                                   duration: 600,
                                   easing: 'easeOutExpo',
                                   delay: anime.stagger(100)
                              });
                         }
                    } 
               }
               if($('.citys-heading').length > 0){
                    if (isScrolledIntoView('.citys-heading') === true) {
                         $('.person').removeClass('hide-person');
                         $('.contacts-address').removeClass('hide-person');
                    }
               }
          }
          $(window).scroll(function(){
               allscrollanis();
          });
          allscrollanis();

          $(".truck-link").click(function() {
               anime({
                    targets: trukani,
                    keyframes: [
                         {rotateY: 180},
                         {translateX: 1000}
                    ],
                    duration: 1000,
                    easing: 'easeOutExpo'
               });
          });
});